module.exports = __webpack_public_path__ + "img/sg_qrcode_whatsapp.55985a2.png";